import React, { useMemo } from "react"
import { Skeleton, Typography } from "@mui/material"
import { useLocation } from "react-router"
import TopBanner from "../../../components/TopBanner"
import { checkExcludingBannerByRoutes } from "./helpers"
import { useStyles } from "./styles"
import { useImpersonationBannerManage } from "../../hooks"
import { IMPERSONATION_BANNER_ID } from "./constants"

interface Props {
  isAuthed: boolean
  excludeRoutes?: string[]
  className?: string
  sticky?: boolean
}

const ImpersonationBannerContainer: React.FC<Props> = ({
  isAuthed,
  excludeRoutes = [],
  className,
  sticky = true
}) => {
  const { classes, cx } = useStyles()

  const location = useLocation()

  // Check if current route should be excluded
  const isExcluded = useMemo(() => {
    return checkExcludingBannerByRoutes(excludeRoutes, location.pathname)
  }, [excludeRoutes, location.pathname])

  const {
    impersonationEnable,
    impersonatedUserName,
    impersonatedUserDistrict,
    impersonatedUserDistrictLoading,
    leaveImpersonationLoading,
    leaveImpersonationHandler
  } = useImpersonationBannerManage({
    isAuthed,
    isNotUsed: isExcluded
  })

  if (!isAuthed || !impersonationEnable || isExcluded) {
    return null
  }

  return (
    <TopBanner
      id={IMPERSONATION_BANNER_ID}
      text={
        <Typography variant="subtitle1" className="clarity-mask">
          Impersonating “{impersonatedUserName || "--"}” in "
          {impersonatedUserDistrictLoading ? (
            <Skeleton className={classes.districtLoadingSkeleton} />
          ) : (
            impersonatedUserDistrict?.name || "--"
          )}
          " District
        </Typography>
      }
      buttonName="Leave Impersonation"
      buttonStartIcon="person-from-portal"
      buttonLoading={leaveImpersonationLoading}
      onButtonClick={leaveImpersonationHandler}
      className={cx({ [classes.rootSticky]: sticky }, className)}
    />
  )
}

export default ImpersonationBannerContainer
